module.exports = __webpack_public_path__ + "src/assets/img/customer-logos/turo.cc0a772eeed675e90dc3fcddc3f6ee8e.png";